export const SET_SHOW_PUBLISH = 'SET_SHOW_PUBLISH'
export const SET_IS_CART = 'SET_IS_CART'
export const SET_ORDER_OBJ = 'SET_ORDER_OBJ'
export const SET_TALKBAO_INDEX = 'SET_TALKBAO_INDEX'
export const SET_GUANGGUANG_INDEX = 'SET_GUANGGUANG_INDEX'
export const SET_IMPRINT_INDEX = 'SET_IMPRINT_INDEX'
export const SET_SHOW_UPDATENUM = 'SET_SHOW_UPDATENUM'
export const SET_FOCUS_ADDREMARK = 'SET_FOCUS_ADDREMARK'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_BOOTHSTORE_DETAIL = 'SET_BOOTHSTORE_DETAIL'
export const SET_ORDER_KEYID = 'SET_ORDER_KEYID'
export const SET_IGET_SALESNUM = 'SET_IGET_SALESNUM'
export const SET_IGET_UPDATESALESNUM = 'SET_IGET_UPDATESALESNUM'
export const SET_BACK_WAITORDER = 'SET_BACK_WAITORDER'
export const SET_ADD_REMARKTEXT = 'SET_ADD_REMARKTEXT'
export const SET_ADD_REMARKOBJ = 'SET_ADD_REMARKOBJ'
export const SET_VIDEO_SHOW = 'SET_VIDEO_SHOW'
export const SET_VIDEO_SRC = 'SET_VIDEO_SRC'
export const SET_Home_POP = 'SET_Home_POP'

export const SET_PASSWORD_STATUS = 'SET_PASSWORD_STATUS'
export const SET_templateLibraryId = 'SET_templateLibraryId'

export const SET_STORE_ID = 'SET_STORE_ID'
export const SET_WRITE_STATE = 'SET_WRITE_STATE'
export const SET_NFC_READTXT = 'SET_NFC_READTXT'
export const SET_NFC_WRITETXT = 'SET_NFC_WRITETXT'
export const SET_LAST_CHIP_UID = 'SET_LAST_CHIP_UID'

export const SET_GEO_INFO = 'SET_GEO_INFO'



// WEBPACK FOOTER //
// ./src/store/mutations-type.js